<template>
  <div>
    <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{ title }}</h4>
            <div class="d-flex justify-content-end mb-2" style="gap: 8px">
              <button type="button" class="btn btn-primary btn-rounded" @click="showFilters()">
                <i class="mdi mdi-filter mr-1"></i> Filtros
              </button>
              <button type="button" class="btn btn-success btn-rounded" @click="showFormatModal()">
                <i class="mdi mdi-file-export-outline mr-1"></i> Exportar Dados
              </button>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-hover w-100">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Grupo</th>
                    <th style="white-space:nowrap">Inscrição</th>
                    <th style="white-space:nowrap">Atualização</th>
                    <th style="white-space:nowrap">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in participants" :key="list.id" :class="{'inativado': parseInt(list.status) === 5}">
                    <td>
                      <h5 class="font-size-14 mb-1" style="white-space: nowrap;text-overflow: ellipsis;max-width: 275px;overflow: hidden;">{{ list.name }}</h5>
                      <p class="text-muted mb-0">{{ list.email }}</p>
                    </td>
                    <td>
                      <GroupBadges :participant="list" />
                    </td>
                    <td style="font-size: 12px !important">{{ list.inscricao }}</td>
                    <td style="font-size: 12px !important">{{ list.atualizacao }}</td>
                    <td>
                      <span
                        :class="statusClass[list.status]"
                        class="badge font-size-12 p-2" style="min-width: 120px">
                          {{ statusList[list.status] }}
                      </span><br />
                      <span
                        v-if="list.ref_status"
                        class="badge font-size-11 p-1 badge-secondary" style="min-width: 120px;margin-top:2px">
                          {{ refstatusList[list.ref_status] }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

    <!-- Modal de escolha de formato -->
    <b-modal v-model="formatModal" title="Exportar Participantes com Acompanhantes" size="md" centered hide-footer>
      <p class="text-muted font-size-13 mb-3">Escolha o formato de exportação:</p>

      <div
        class="format-option"
        :class="{ 'format-option--selected': selectedFormat === 'stacked' }"
        @click="selectedFormat = 'stacked'"
      >
        <div class="d-flex align-items-start">
          <div class="format-icon mr-3">
            <i class="bx bx-list-ul"></i>
          </div>
          <div class="flex-grow-1">
            <h6 class="mb-1 font-size-14">Empilhado</h6>
            <p class="text-muted mb-0 font-size-12">Participante em uma linha, acompanhante(s) na linha de baixo, vinculados.</p>
          </div>
          <div class="format-check" v-if="selectedFormat === 'stacked'">
            <i class="bx bx-check-circle text-success font-size-20"></i>
          </div>
        </div>
        <div class="format-preview mt-2">
          <table class="table table-sm table-bordered mb-0 font-size-11">
            <tbody>
              <tr class="bg-light">
                <td><strong>PARTICIPANTE</strong></td>
                <td>João Silva</td>
                <td>joao@email.com</td>
              </tr>
              <tr>
                <td class="text-muted pl-3">ACOMPANHANTE</td>
                <td class="text-muted">Maria Silva</td>
                <td class="text-muted">maria@email.com</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        class="format-option mt-2"
        :class="{ 'format-option--selected': selectedFormat === 'inline' }"
        @click="selectedFormat = 'inline'"
      >
        <div class="d-flex align-items-start">
          <div class="format-icon mr-3">
            <i class="bx bx-columns"></i>
          </div>
          <div class="flex-grow-1">
            <h6 class="mb-1 font-size-14">Lado a lado</h6>
            <p class="text-muted mb-0 font-size-12">Participante e acompanhante(s) na mesma linha, com colunas extras.</p>
          </div>
          <div class="format-check" v-if="selectedFormat === 'inline'">
            <i class="bx bx-check-circle text-success font-size-20"></i>
          </div>
        </div>
        <div class="format-preview mt-2">
          <table class="table table-sm table-bordered mb-0 font-size-11">
            <tbody>
              <tr class="bg-light">
                <td>João Silva</td>
                <td>joao@email.com</td>
                <td class="text-muted" style="border-left: 2px solid #556ee6">Acomp: Maria</td>
                <td class="text-muted">maria@email.com</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="text-right mt-3">
        <b-button variant="light" class="mr-2" @click="formatModal = false">Cancelar</b-button>
        <b-button variant="success" :disabled="!selectedFormat" @click="doExport()">
          <i class="bx bx-download mr-1"></i> Exportar
        </b-button>
      </div>
    </b-modal>

    <modal-filter ref="modalFilter" @participantFiltered="getReport"></modal-filter>
    <export-modal ref="exportModal" title="Exportar Acompanhantes" />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import serviceReport from '../services'
import modalFilter from '@/components/modals/filters/ParticipantFilter'
import ExportModal from '@/components/modals/ExportModal'
import GroupBadges from '@/components/GroupBadges'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    GroupBadges,
    modalFilter,
    ExportModal
  },
  name: 'report-participants-companions',
  page: {
    title: 'Relatório de Participantes com Acompanhantes',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      params: {},
      totalRows: 1,
      rows: 0,
      currentPage: 1,
      participants: [],
      statusClass: ['badge-dark', 'badge-primary', 'badge-warning', 'badge-success', 'badge-danger', 'badge-secondary'],
      perPage: 20,
      title: 'Relatório de Participantes com Acompanhantes',
      items: [{
        text: 'Relatórios'
      },
      {
        text: 'Participantes com Acompanhantes',
        active: true
      }],
      formatModal: false,
      selectedFormat: 'stacked'
    }
  },
  mounted () {
    let loeader = this.$loading.show()
    serviceReport.listParticipants({ limit: this.perPage, include: 'group' }).then((res) => {
      this.participants = res.data
      this.rows = res.meta.pagination.total
      this.currentPage = res.meta.pagination.current_page
      loeader.hide()
    }).catch(error => {
      console.log(error)
      loeader.hide()
    })
    this.totalRows = this.rows
    this.GetStatus()
    this.GetRefStatus()
  },
  computed: {
    ...mapState('settings', ['statusList', 'refstatusList'])
  },
  methods: {
    ...mapActions('settings', { GetStatus: 'GetStatusList' }),
    ...mapActions('settings', { GetRefStatus: 'GetRefStatusList' }),
    showFilters () {
      this.$refs.modalFilter.open()
    },
    showFormatModal () {
      this.formatModal = true
    },
    doExport () {
      this.formatModal = false
      this.$refs.exportModal.start(() => serviceReport.exportParticipantsCompanions(this.params, this.selectedFormat))
    },
    getReport (filter = '') {
      let loeader = this.$loading.show()
      let params = {
        group_id: filter.group_id || null,
        noCompanion: 1,
        limit: this.perPage,
        page: this.currentPage,
        status: filter.status || null,
        ref_status: filter.ref_status || null,
        city: filter.city || null,
        district: filter.district || null,
        isOnline: filter.isOnline || null,
        need_payment: filter.need_payment || null,
        payment_completed: filter.payment_completed || null,
        created_start: filter.created_start ? this.$moment(filter.created_start).format('YYYY-MM-DD') : null,
        created_end: filter.created_end ? this.$moment(filter.created_end).format('YYYY-MM-DD') : null,
        confirmation_date_start: filter.confirmation_date_start ? this.$moment(filter.confirmation_date_start).format('YYYY-MM-DD') : null,
        confirmation_date_end: filter.confirmation_date_end ? this.$moment(filter.confirmation_date_end).format('YYYY-MM-DD') : null,
        aereo: filter.aereo || null,
        companion: filter.companion || null,
        csm: filter.csm || null,
        school: filter.school || null,
        food_restriction: filter.food_restriction || null
      }
      params.tags = filter.tagsIds || null
      this.params = params
      serviceReport.listParticipants(params).then((res) => {
        this.participants = res.data
        if (res.data.length > 0) {
          this.rows = res.meta.pagination.total
          this.currentPage = res.meta.pagination.current_page
        }
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
    }
  },
  watch: {
    currentPage () { this.updateList() },
    total () { this.updateList() },
    dataPerPage () { this.updateList() }
  }
}
</script>
<style scoped>
.inativado { background: #f7ebeb }
.table-responsive { min-height: 300px;}

.format-option {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 14px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.format-option:hover {
  border-color: #c3cfe2;
  background: #fafbfc;
}
.format-option--selected {
  border-color: #34c38f;
  background: rgba(52, 195, 143, 0.03);
}
.format-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f1f3f7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.format-icon i {
  font-size: 20px;
  color: #556ee6;
}
.format-preview {
  background: #f8f9fa;
  border-radius: 4px;
  padding: 6px;
}
.format-preview .table {
  margin-bottom: 0;
}
.format-preview td {
  padding: 4px 8px;
}
</style>
